export default __webpack_public_path__ + "static/apple-icon-152x152-b5294c5786795a9002c3a06b8230e79a.png";